<template>
  <CRow>
    <CCol
      v-for="(product, index) in productsAllowed"
      :key="index"
      :lg="12"
    >
      <CCard>
        <CCardHeader>
          <strong>Tệp sản xuất sản phẩm: {{product.product}}</strong>
          <div class="card-header-actions">
            <strong v-if="product.app_temp_md5 != product.app_main_md5 && product.app_temp_md5 != ''" style="color: red"> Bạn có 1 yêu cầu chờ phê duyệt</strong>
            <strong v-else>Không có yêu cầu phê duyệt</strong>
          </div>
        </CCardHeader>
        <CCardBody>
          <CRow>
            <CCol>
              <CCard>
                <CCardHeader>
                  <strong>Tệp chờ phê duyệt</strong>
                </CCardHeader>

                <CCardBody>
                  <table>
                    <tr>
                      <td class="text-right">Tên Tệp:</td>
                      <td style="font-weight: bold;">{{product.app_temp}}</td>
                    </tr>
                    <tr>
                      <td class="text-right">MD5: </td>
                      <td style="font-weight: bold;">{{product.app_temp_md5}}</td>
                    </tr>
                    <tr>
                      <td class="text-right">CRC32: </td>
                      <td style="font-weight: bold;">{{product.app_temp_crc32}}</td>
                    </tr>
                  </table>
                </CCardBody>

              </CCard>
            </CCol>
            <CCol>
              <CCard>
                <CCardHeader>
                  <strong>Tệp đã được phê duyệt</strong>
                </CCardHeader>
                <CCardBody>
                  <table>
                    <tr>
                      <td class="text-right">Tên Tệp:</td>
                      <td style="font-weight: bold;">
                        <a
                          :href="product.app_main_link"
                          download
                          class="text-primary"
                          style="cursor: pointer;">
                          {{ product.app_main }}
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td class="text-right">MD5: </td>
                      <td style="font-weight: bold;">{{product.app_main_md5}}</td>
                    </tr>
                    <tr>
                      <td class="text-right">CRC32: </td>
                      <td style="font-weight: bold;">{{product.app_main_crc32}}</td>
                    </tr>
                  </table>
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter v-if="product.app_temp_md5 != product.app_main_md5 && product.app_temp_md5 != ''" >
          <CRow class="d-flex justify-content-center">
            <CButton :disabled="product.app_temp_md5 == product.app_main_md5"
                     color="primary" class="mx-2" style="width: 200px"
                     @click="accept(product.product)">
              PHÊ DUYỆT
            </CButton>
            <CButton :disabled="product.app_temp == ''"
                     color="danger" class="mx-2" style="width: 200px"
                     @click="reject(product.product)">
              TỪ CHỐI
            </CButton>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
export default {
  data() {
    return {
      userName: '',
      userRole: '',
      isSuper: false,
      productsAllowed: [],
    };
  },
  created() {
    this.userRole = localStorage.getItem('role')
    this.isSuper = ((this.userRole === 'root') || (this.userRole === 'super'))
    this.userName = localStorage.getItem('username')
    this.refreshPage()
  },
  methods: {
    refreshPage() {
      this.$request.get(`/api/custom/info/${this.userName}`).
      then(res=>{
        // console.log(res.data)
        this.customer=res.data.customer
        this.productsAllowed=res.data.productsAllowed

        if(this.customer.status === ''){
          this.customer.status= 'Chưa kiểm tra'
        }
      })
    },
    accept(prdName) {
      // console.log('Lưu contract: ', this.contract)
      this.$swal.fire({
        title: "Phê duyệt tệp sản xuất?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/custom/binaries_control`, {
            action: 'accept',
            product: prdName,
          }).
          then(res => {
            this.refreshPage()
            if(res.data.status === 'success') {
              this.contract = res.data.contract;
              this.$swal.fire({
                icon: "success",
                title: "Phê duyệt tệp sản xuất",
                html: "Phê duyệt thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Phê duyệt tệp sản xuất",
                html: "Phê duyệt tệp " +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    reject(prdName) {
      // console.log('Lưu contract: ', this.contract)
      this.$swal.fire({
        title: "Từ chối tệp sản xuất?",
        showDenyButton: false,
        showCancelButton: true,
      }).then((result) => {
        if (result.isConfirmed) {
          this.$request.post(`/api/custom/binaries_control`, {
            action: 'reject',
            product: prdName,
          }).
          then(res => {
            this.refreshPage()
            if(res.data.status === 'success') {
              this.contract = res.data.contract;
              this.$swal.fire({
                icon: "success",
                title: "Từ chối tệp sản xuất",
                html: "Từ chối thành công"
              });
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Từ chối tệp sản xuất",
                html: "Từ chối tệp " +
                  "<br>thất bại: " + res.data.status,
              });
            }
          })
        }
      });
    },
    downloadFile(fileName) {
      // console.log('downloadFile', fileName)
      this.$request.get(`/api/custom/download/${fileName}`, { responseType: 'blob' })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = fileURL;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(fileURL);
          // document.body.removeChild(link); // Clean up
        })
        .catch(error => {
          console.error('Error downloading the file:', error);
        });
    },
  },
};
</script>
